<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lXxkcF/tc-custom/9780253008671.jpg?1705766093020" alt="This image is the cover for the book Tribal Knot, Break Away Book Club Edition"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tribal Knot, Break Away Book Club Edition
      </h1>
      <p class="bookDescription body article font2">
        <b>The Pushcart Prize-winning author’s multi-generational memoir interweaves stories across more than a century in a “loving reminder of the ties that bind” (Lee Martin, <i>From Our House and Turning Bones</i>).</b><br/>  <br/> Are we responsible for, and to, those forces that have formed us—our families, friends, and communities? Where do we leave off and others begin? In <i>The Tribal Knot</i>, award-winning poet and author Rebecca McClanahan mines her personal family history to explore provocative questions about legacy, identity, and familial connection.<br/><br/> Poring over letters, artifacts, and documents that span more than a century, McClanahan discovers a tribe of hardscrabble Midwest farmers, hunters, trappers, and laborers struggling to hold tight to the ties that bind them, through poverty, war, political upheavals, illness and accident, filicide and suicide, economic depressions, personal crises, and global disasters. Like the practitioners of Victorian "hair art" who wove strands of family members' hair into a single design, McClanahan braids her ancestors' stories into a single intimate narrative of her search to understand herself and her place in the family's complex past.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rebecca McClanahan
      </h2>
      
      <p class="authorDescription body article">Rebecca McClanahan, the author of nine previous books, including The Riddle Song and Other Rememberings, which won the Glasgow award in nonfiction, is the recipient of a Pushcart Prize, the Wood Prize from Poetry, and fellowships from New York Foundation for the Arts and the North Carolina Arts Council.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2e8bf4e2